import React from "react";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import { driver, truck, trailer, container } from "../../constants/common";

import images from "../../assets/img/images";

const MatchSuccess = (props) => {
  const { data } = props;
  const [stats, setStats] = React.useState();

  const types = {
    driver,
    truck,
    trailer,
    container,
  };

  React.useEffect(() => {
    let newStats = {
      driver: { faceMatch: { matched: 0, total: 0 } },
      truck: {
        lprMatch: { matched: 0, total: 0 },
        ocrMatch: { matched: 0, total: 0 },
      },
      trailer: {
        lprMatch: { matched: 0, total: 0 },
        ocrMatch: { matched: 0, total: 0 },
      },
    };
    if (data) {
      data.forEach((row) => {
        let eventType = get(row, ["type", "id"]);
        if ([5, 6].includes(eventType)) {
          newStats.driver.faceMatch.total += 1;
          newStats.driver.faceMatch.matched += eventType === 5 ? 1 : 0;
        } else if ([57].includes(eventType)) {
          if (get(row, ["profile", "type", "id"]) === 2) {
            newStats.truck.lprMatch.total += 1;
            newStats.truck.lprMatch.matched += row.recognized === true ? 1 : 0;
          } else if (get(row, ["profile", "type", "id"]) === 3) {
            newStats.trailer.lprMatch.total += 1;
            newStats.trailer.lprMatch.matched +=
              row.recognized === true ? 1 : 0;
          }
        } else if ([63].includes(eventType)) {
          if (get(row, ["profile", "type", "id"]) === 2) {
            newStats.truck.ocrMatch.total += 1;
            newStats.truck.ocrMatch.matched += row.recognized === true ? 1 : 0;
          } else if (get(row, ["profile", "type", "id"]) === 3) {
            newStats.trailer.ocrMatch.total += 1;
            newStats.trailer.ocrMatch.matched +=
              row.recognized === true ? 1 : 0;
          }
        }
      });
    }
    setStats(newStats);
  }, [data]);

  const renderRow = (type) => {
    if (!stats || !stats[type]) {
      return null;
    }

    return (
      <Grid container alignItems="center" style={{ height: "35px" }}>
        <Grid item className="text-center" style={{ width: "45px" }}>
          <img
            src={
              type === driver
                ? images.humanIconBlack
                : images[`${type}IconBlack`]
            }
            height="20px"
            style={{ maxWidth: "30px", display: "block", margin: "auto" }}
            alt={`${type}_icon`}
          />
        </Grid>
        {type === driver ? (
          <Grid item className="text-54">
            {`${stats.driver.faceMatch.matched}/${
              stats.driver.faceMatch.total
            } (${I18n.get("site_face")})`}
          </Grid>
        ) : (
          <>
            <Grid item className="text-54">
              {`${stats[type].lprMatch.matched}/${
                stats[type].lprMatch.total
              } (${I18n.get("stats_lprTitle")})`}
            </Grid>
            <Grid item className="text-54" style={{ margin: "0px 5px" }}>
              {"--"}
            </Grid>
            <Grid item className="text-54">
              {`${stats[type].ocrMatch.matched}/${
                stats[type].ocrMatch.total
              } (${I18n.get("stats_ocrTitle")})`}
            </Grid>
          </>
        )}
      </Grid>
    );
  };

  return (
    <Grid container direction="column" style={{ marginTop: "-10px" }}>
      {!data
        ? I18n.get("site_noData")
        : Object.values(types).map((t) => (
            <Grid item key={t}>
              {renderRow(t)}
            </Grid>
          ))}
    </Grid>
  );
};

export default MatchSuccess;
